"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _customBoxNftBlind = _interopRequireDefault(require("@/components/customChildren/customBoxNftBlind"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    CustomBox: _customBoxNftBlind.default
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  data: function data() {
    return {
      defaultData: [{
        image: 'https://artimg2.artart.cn/image/20211022/447940859f11823f4adf5b7fe249b648.png',
        name: '艺术盲盒',
        tags: [],
        price: '',
        sign: ''
      }, {
        image: 'https://artimg2.artart.cn/image/20211023/7c0028ed94e3f35e7859cac94884f6ed.png',
        name: '艺术盲盒',
        tags: [],
        price: '',
        sign: ''
      }, {
        image: 'https://artimg2.artart.cn/image/20211023/7c0028ed94e3f35e7859cac94884f6ed.png',
        name: '艺术盲盒',
        tags: [],
        price: '',
        sign: ''
      }, {
        image: 'https://artimg2.artart.cn/image/20211022/447940859f11823f4adf5b7fe249b648.png',
        name: '艺术盲盒',
        tags: [],
        price: '',
        sign: ''
      }, {
        image: 'https://artimg2.artart.cn/image/20211022/447940859f11823f4adf5b7fe249b648.png',
        name: '艺术盲盒',
        tags: [],
        price: '',
        sign: ''
      }, {
        image: 'https://artimg2.artart.cn/image/20211022/447940859f11823f4adf5b7fe249b648.png!120a',
        name: '艺术盲盒',
        tags: [],
        price: '',
        sign: ''
      }]
    };
  },
  /**
     * 计算属性
     * @type {Object}
     */
  computed: {
    viewData: function viewData() {
      if (this.content.type === 2 && this.content.data && this.content.data.length > 0) {
        return this.content.data;
      }
      return this.defaultData;
    },
    isComponent: function isComponent() {
      return this.$route.name === 'basicsDiy';
    }
  },
  /**
     * 页面渲染前
     * @return {[type]} [description]
     */
  created: function created() {},
  /**
     * 数据监听
     * @type {Object}
     */
  watch: {},
  /**
     * 页面加载执行
     * @return {[type]} [description]
     */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {}
};
exports.default = _default;